// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"438":"1c1469a9","560":"5583c17a","930":"25f13f30"}[chunkId] + ".chunk.css";
};